import type { Tour } from '../../types';

export const pfilesTour: Tour = {
  id: 'institution-pfiles',
  name: 'Personnel Files Tour',
  description: 'Learn how to manage staff personnel files (PFiles)',
  category: 'institution',
  showProgress: true,
  requiredPath: '/pfiles',
  steps: [
    {
      id: 'pfiles-1',
      target: 'pfiles-header',
      title: 'Personnel File Management',
      content: 'The PFile system manages staff records using a jacket-based approach. Each employee has a personal file jacket containing all their documents.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'pfiles-2',
      target: 'pfiles-search',
      title: 'Search Staff',
      content: 'Quickly find staff members by name, staff ID, department, or position. Use filters to narrow down results.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'pfiles-3',
      target: 'pfiles-create-btn',
      title: 'Create New PFile',
      content: 'Start a new personnel file jacket for a staff member. You\'ll enter their basic information and the jacket will be assigned a unique identifier.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'pfiles-4',
      target: 'pfiles-list',
      title: 'PFile Directory',
      content: 'View all staff PFile jackets. Each entry shows the staff member\'s name, department, current location of their physical jacket, and status.',
      position: 'right',
      spotlight: true,
    },
    {
      id: 'pfiles-5',
      target: 'pfiles-status-filter',
      title: 'Filter by Status',
      content: 'Filter PFiles by their current status: Active, On Leave, Transferred, or Retired.',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'pfiles-6',
      target: 'pfiles-request-btn',
      title: 'Request Movement',
      content: 'Request to transfer a physical jacket to your location. All movements are tracked for audit purposes.',
      position: 'left',
      spotlight: true,
    },
    {
      id: 'pfiles-7',
      target: 'pfiles-jacket-details',
      title: 'Jacket Details',
      content: 'View the complete history of a PFile jacket including all documents, movement history, and access logs.',
      position: 'left',
      spotlight: true,
      actionLabel: 'Finish Tour',
    },
  ],
};
